import React from 'react';
import { Box, Grid } from '@mui/material';
import SectionHeader from '../SectionHeader';

export default function RelatedSectionShell({ section, children }) {
  if (!section) return null;
  return (
    <Box sx={{ mb: 4, maxWidth: 1200 }}>
      <SectionHeader
        metaTitle={section.metaTitle ?? null}
        title={section.title}
        intro={null}
        updatedAt={section.updatedAt}
      />
      {/* Optional grid content from children */}
      {children}
    </Box>
  );
}

/** Helper to render a tile grid identical to the dashboard rules */
export function TilesGrid({ tiles, renderTile }) {
  if (!Array.isArray(tiles) || tiles.length === 0) return null;
  return (
    <Grid container spacing={2}>
      {tiles.map((t, i) => {
        // Keep the same responsive sizing convention as the dashboard
        const gridProps = t.type === 'jobSatisfactionSummary'
          ? { xs: 12 }
          : { xs: 12, sm: 6, md: 4, lg: 3 };
        return (
          <Grid item key={i} {...gridProps}>
            {renderTile(t, i)}
          </Grid>
        );
      })}
    </Grid>
  );
}
